<script setup>
import { documentKind } from '../lib/documents'
import DownloadLink from './DownloadLink.vue'

defineProps({
  documents: { type: Array, required: true },
})
</script>

<template>
  <ul class="divide-y divide-slate-100 overflow-hidden rounded-lg border border-slate-100">
    <li
      v-for="doc in documents"
      :key="doc.id"
      class="flex items-center gap-3 px-4 py-3.5 transition-colors hover:bg-up-bg"
    >
      <span
        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-up-navy"
        aria-hidden="true"
      >
        <component :is="documentKind(doc.kind).icon" class="h-5 w-5" />
      </span>

      <div class="min-w-0">
        <p class="truncate font-medium text-up-navy">{{ doc.name }}</p>
        <p class="mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-slate-500">
          <span class="rounded bg-slate-100 px-1.5 py-0.5 font-medium">{{ documentKind(doc.kind).label }}</span>
          <span>{{ doc.size }}</span>
          <!-- separador junto da data para não ficar órfão ao quebrar a linha -->
          <span><span class="text-slate-300" aria-hidden="true">· </span>Atualizado em {{ doc.updated_at }}</span>
        </p>
      </div>

      <span
        class="ml-auto hidden shrink-0 rounded-md bg-up-bg px-2.5 py-1 text-xs text-slate-500 sm:inline"
      >{{ doc.category }}</span>

      <DownloadLink :id="doc.id" :name="doc.name" :available="doc.downloadable" hover-class="hover:bg-slate-100" />
    </li>
  </ul>
</template>
